import { cn } from '@/lib/utils';

const Pill = ({
  children,
  variant = 'outline',
  className,
}: {
  children: React.ReactNode;
  variant?: 'violet' | 'brown' | 'outline' | 'green' | 'red' | 'white';
  className?: string;
}) => (
  <div
    className={cn(
      'flex h-[30px] items-center space-x-2 rounded-full px-2 py-1.5 text-xs',
      {
        'bg-brand-violet/10 text-brand-violet': variant === 'violet',
        'bg-brand-brown/10 text-brand-brown': variant === 'brown',
        'text-primary border bg-transparent': variant === 'outline',
        'bg-brand-green-300/10 text-brand-green-300': variant === 'green',
        'bg-brand-red/10 text-brand-red': variant === 'red',
        'bg-white/40': variant === 'white',
      },
      className,
    )}
  >
    {children}
  </div>
);

export { Pill };
